import { useRef, useState } from 'react';
import 'tippy.js/dist/tippy.css';
import './style.css';

//swiper slide
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

import Load from '../load/cast';

export default function Cast( { cast } ) {

    const image_path = 'https://image.tmdb.org/t/p/w138_and_h175_face';

    const [ castLengthVisible, setCastLengthVisible ] = useState(15);
 
    const swiperRef = useRef(null);

    const loadMore = () => {
        const remainingElenco = cast.length - castLengthVisible;
        const nextBatch = Math.min(remainingElenco, 10);
        setCastLengthVisible(prevCastLengthVisible => prevCastLengthVisible + nextBatch);
    };

    return (
        <>
            {(cast && cast.length >= 1) &&
                <div className='div-elenco-season' id='div-elenco-season'>
                    <h2 className="h2-elenco-details-movie h2-titulo-sections" id="h2-sugestoes">Elenco</h2>
                    <Swiper
                        slidesPerView={'auto'}
                        spaceBetween={10}
                        freeMode={false}
                        pagination={{
                        clickable: true,
                        }}
                        className="mySwiper swiper-elenco"
                        id="swiper-slide"
                        ref={swiperRef}
                    >
                        {cast?.slice(0, castLengthVisible).map((ator, key) =>{
                            return(
                                <SwiperSlide key={key} className='swiper-slide-elenco'>
                                    <button className='ator-season'>
                                        <img loading="lazy" src={ator.profile_path ? (`${image_path}${ator.profile_path}`) : 'https://dflix.netlify.app/imagens/img-avatar.png'} alt={ator.name} onError={({ currentTarget }) => {currentTarget.onerror = null; currentTarget.src='https://dflix.netlify.app/imagens/img-avatar.png';}}/>
                                        <section className='section-nome-ator-personagem'>
                                            {ator.original_name && 
                                                <span className='nome-ator'>{ator.original_name}</span>
                                            }
                                            <span className='nome-personagem'>{ator.character}</span>
                                        </section>
                                    </button>
                                </SwiperSlide>
                            )
                        })}
                        <SwiperSlide>
                            {cast?.length > castLengthVisible && (
                                <button className='botao-playlist botao-add-playlist bt-more-elenco' onClick={loadMore}><i className='fas fa-chevron-right'></i></button>
                            )}
                        </SwiperSlide>
                        
                    </Swiper>
                </div>
            }
        </>
    )
}